module.exports = __webpack_public_path__ + "static/media/banner_aliexpress.723a1245.png";